{
  "kk": {
    "productsErrorCard": {
      "title": "Тізім жүктелмей тұр",
      "contentText": "Деректердің бәрін көру үшін әрекетті қайталап көріңіз",
      "retry": "Қайталау"
    }
  },
  "ru": {
    "productsErrorCard": {
      "title": "Список не загрузился",
      "contentText": "Повторите попытку, чтобы загрузить все данные",
      "retry": "Повторить попытку"
    }
  }
}
